<div libDialogHeader>
  <div class="cab">
    <span class="cab__icono" [class.cab__icono--aprobar]="!rechaza()" aria-hidden="true">
      <lib-icon [name]="rechaza() ? 'Undo2' : 'Check'" [size]="20" />
    </span>
    <h3 class="cab__titulo">{{ datos().titulo }}</h3>
  </div>
  <button
    type="button"
    class="cab__cerrar"
    [attr.aria-label]="datos().textos.cancelar"
    (click)="cancelar()"
  >
    <lib-icon name="X" [size]="20" />
  </button>
</div>

<div libDialogBody>
  @if (unDocumento()) {
    <!-- Un documento: su ficha completa, para saber sobre que se escribe. -->
    @let doc = datos().documentos[0];
    <section class="ficha">
      <div class="ficha__cab">
        <span class="ficha__tipo">{{ doc.tipo }}</span>
        <span class="ficha__numero">{{ doc.numero }}</span>
        <span class="ficha__valor">{{ moneda(doc.valor) }}</span>
      </div>
      <dl class="ficha__datos">
        @for (dato of doc.datos; track dato.rotulo) {
          <div [class.ficha__ancho]="dato.ancho">
            <dt>{{ dato.rotulo }}</dt>
            <dd>{{ dato.valor }}</dd>
          </div>
        }
      </dl>
    </section>
  } @else {
    <!-- El lote: cada documento en una linea y el total de lo que se rechaza. -->
    <section class="ficha ficha--lote">
      <ul class="lote">
        @for (doc of datos().documentos; track doc.id) {
          <li class="lote__fila">
            <span class="ficha__tipo">{{ doc.tipo }}</span>
            <span class="lote__numero">{{ doc.numero }}</span>
            <span class="lote__tercero">{{ doc.tercero }}</span>
            <span class="lote__valor">
              {{ moneda(doc.valor) }}
            </span>
          </li>
        }
      </ul>
      <div class="lote__total">
        <span>{{ datos().textos.total }}</span>
        <span class="ficha__valor">{{ moneda(total()) }}</span>
      </div>
    </section>
  }

  <p class="aviso">
    <lib-icon name="Info" [size]="16" aria-hidden="true" />
    <span>{{ datos().aviso }}</span>
  </p>

  @if (rechaza()) {
    <!-- La etiqueta va ARRIBA de la caja, como en todo campo del perfil 3.0. -->
    <div class="observacion">
      <lib-field-label [label]="datos().textos.observacion ?? ''" [required]="true" />
      <lib-textarea
        [externalLabel]="true"
        [placeholder]="datos().textos.ejemplo ?? ''"
        [rows]="4"
        [required]="true"
        [maxLength]="datos().maximo"
        [showCharCount]="true"
        [errorMsg]="error()"
        [value]="observacion()"
        (valueChange)="observacion.set($event)"
      />
    </div>
  }
</div>

<lib-dialog-footer>
  <lib-button [variant]="varianteCancelar" (clicked)="cancelar()">{{
    datos().textos.cancelar
  }}</lib-button>
  <lib-button
    [variant]="rechaza() ? 'danger' : 'primary'"
    [prefixIcon]="rechaza() ? 'Undo2' : 'Check'"
    (clicked)="confirmar()"
  >
    {{ datos().textos.confirmar }}
  </lib-button>
</lib-dialog-footer>
